export default function () {
  return {
    perguntas: {
      data: [],
    },
    pergunta: {
      attributes: {
        titulo: '',
      },
      relationships: {
      },
    },
  };
}
